// Menú lateral: la única lista de pantallas del sistema. La usan el Layout (para dibujar el
// menú) y Apariencia (para la lista "Aplicar en"): una pantalla nueva que se agregue aquí
// aparece sola en los dos lugares.
//
// Cada enlace:
//   ruta, icono, texto      lo que se ve en el menú (texto puede depender del rol)
//   ver(roles)              a quién se le muestra
//   exacta                  solo se resalta en esa ruta exacta (para "/")
//   tambien                 otra ruta que deja resaltado el enlace
//   modulo / nombreModulo   agrupa varias pantallas bajo un mismo nombre en Apariencia
//                           (sin modulo, cada enlace es su propio grupo)
//   rutasExtra              pantallas fuera del menú que siguen el tema de este grupo
export const SECCIONES_MENU = [
  {
    titulo: "Principal",
    enlaces: [
      { ruta: "/", icono: "📊", texto: "Dashboard", exacta: true, ver: (r) => !r.esPagos, modulo: "dashboard" },
      {
        ruta: "/nueva",
        icono: "📝",
        texto: "Nueva Solicitud",
        ver: (r) => !r.esPagos,
        modulo: "solicitudes",
        nombreModulo: "Solicitudes",
        rutasExtra: ["/solicitud"],
      },
    ],
  },
  {
    titulo: "Gestión",
    enlaces: [
      { ruta: "/bandeja", icono: "🗂️", texto: "Solicitudes", ver: (r) => r.esCompras, modulo: "bandeja", nombreModulo: "Bandeja de Compras" },
      // "Aprobaciones" agrupa lo pendiente y el historial (Mis aprobaciones):
      // se queda resaltada en cualquiera de las dos pantallas.
      { ruta: "/pendientes", icono: "✅", texto: "Aprobaciones", tambien: "/aprobadas", ver: (r) => r.esAprobador, modulo: "aprobaciones" },
      { ruta: "/pagos", icono: "💳", texto: "Pagos", ver: (r) => r.esPagos || r.esCompras, modulo: "pagos" },
    ],
  },
  {
    titulo: "Registros",
    enlaces: [
      {
        ruta: "/historico",
        icono: "🕘",
        texto: (r) => (r.esCompras || r.esAprobador ? "Histórico" : "Historial de solicitudes"),
        ver: (r) => !r.esPagos,
        modulo: "historico",
        nombreModulo: "Histórico y Reportes",
      },
      { ruta: "/actas", icono: "📄", texto: "Actas", ver: (r) => r.esCompras || r.esAprobador, modulo: "actas" },
      { ruta: "/activos", icono: "🏷️", texto: "Activos Fijos", ver: (r) => r.esCompras || r.esAprobador, modulo: "activos" },
      { ruta: "/reportes", icono: "📈", texto: "Reportes", ver: (r) => r.esCompras || r.esAprobador, modulo: "historico" },
    ],
  },
  {
    titulo: "Administración",
    enlaces: [
      { ruta: "/catalogos", icono: "📚", texto: "Catálogos", ver: (r) => r.esCompras, modulo: "catalogos" },
      { ruta: "/usuarios", icono: "👥", texto: "Usuarios", ver: (r) => r.esAdmin, modulo: "usuarios" },
      {
        ruta: "/firma",
        icono: "⚙️",
        texto: "Configuración",
        ver: (r) => r.esAdmin,
        modulo: "configuracion",
        nombreModulo: "Configuración y Parámetros",
      },
      { ruta: "/parametros", icono: "🎚️", texto: "Parámetros", ver: (r) => r.esAdmin, modulo: "configuracion" },
      { ruta: "/modo-seguridad", icono: "🔒", texto: "Modo de Seguridad", ver: (r) => r.esAdmin, modulo: "configuracion" },
    ],
  },
];

const textoDe = (enlace, roles) => (typeof enlace.texto === "function" ? enlace.texto(roles) : enlace.texto);

// Clave de un enlace sin grupo: la ruta sin "/" (por ejemplo "/inventario" → "inventario").
const claveDeRuta = (ruta) => ruta.replace(/^\//, "").replace(/[^a-z0-9-]/gi, "-").toLowerCase() || "inicio";

// El menú tal como lo ve un usuario: solo sus enlaces y con el texto de su rol.
export function seccionesParaRoles(roles) {
  return SECCIONES_MENU.map((seccion) => ({
    titulo: seccion.titulo,
    enlaces: seccion.enlaces
      .filter((enlace) => enlace.ver(roles))
      .map((enlace) => ({ ...enlace, texto: textoDe(enlace, roles) })),
  })).filter((seccion) => seccion.enlaces.length > 0);
}

// Grupos para Apariencia: "Menú lateral" y uno por cada pantalla (o grupo) del menú.
export function modulosDelMenu() {
  const modulos = [{ clave: "menu", nombre: "Menú lateral", rutas: [] }];
  SECCIONES_MENU.forEach((seccion) =>
    seccion.enlaces.forEach((enlace) => {
      const clave = enlace.modulo || claveDeRuta(enlace.ruta);
      const rutas = [enlace.ruta, enlace.tambien, ...(enlace.rutasExtra || [])].filter(Boolean);
      const existente = modulos.find((m) => m.clave === clave);
      if (existente) {
        existente.rutas.push(...rutas);
        if (enlace.nombreModulo) existente.nombre = enlace.nombreModulo;
      } else {
        // El nombre por defecto es el texto del menú que ve el personal.
        const nombre = enlace.nombreModulo || textoDe(enlace, { esCompras: true, esAprobador: true, esAdmin: true });
        modulos.push({ clave, nombre, rutas });
      }
    })
  );
  return modulos;
}
